import type { DeviceTypeSource } from 'core/contexts/device-types/device-types.type';

export const deviceKeys = {
    all: ['devices'] as const,
    lists: () => [...deviceKeys.all, 'list'] as const,
    list: <TParams>(params: TParams) => [...deviceKeys.lists(), params] as const,
    details: () => [...deviceKeys.all, 'detail'] as const,
    detail: (id: string) => [...deviceKeys.details(), id] as const,
    types: (source: DeviceTypeSource) => [...deviceKeys.all, 'types', source] as const,
    filter: <TField>(field: TField) => [...deviceKeys.all, 'filter', field] as const,
    configurationInstances: () => [...deviceKeys.all, 'configuration-instances'] as const,
    assignEapSettings: () => [...deviceKeys.all, 'assign-eap-settings'] as const,
    assignEapSettingsList: () => [...deviceKeys.assignEapSettings(), 'list'] as const,
    assignEapSettingsQrList: () => [...deviceKeys.assignEapSettings(), 'qr-list'] as const,
};
